import React from 'react';

const Icon = ({ children }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

export const PrintIcon = () => (
    <Icon><rect x="6" y="9" width="12" height="7" rx="1" /><path d="M7 9V4h10v5M8 16v4h8v-4" /></Icon>
);

export const DownloadIcon = () => (
    <Icon><path d="M12 4v11M8 11l4 4 4-4" /><path d="M4 19h16" /></Icon>
);

/** A drop, filled with the current canvas colour when there is one. */
export const FillIcon = ({ fill }) => (
    <Icon><path d="M12 3c3 3.5 6 7 6 10a6 6 0 1 1-12 0c0-3 3-6.5 6-10Z" fill={fill || 'none'} /></Icon>
);

/** Clear the whole canvas: a broom, distinct from the dock's eraser and from delete. */
export const ClearIcon = () => (
    <Icon>
        <path d="M20 4l-7.5 7.5" />
        <path d="M10.4 9.4l4.2 4.2-4.3 5.7-5.6-5.6z" />
        <path d="M12.5 11.5l-5 5" />
    </Icon>
);

/** Shape colour: the classic tilted paint bucket, its body filled with the selected shape's colour. */
export const PaletteIcon = ({ fill }) => (
    <Icon>
        <path d="M3 11h14l-7 7z" fill={fill || 'none'} stroke="none" />
        <path d="M10 4l7 7-7 7-7-7z" />
        <path d="M3 11h14" />
        <path d="M10 4L7 1" />
        <path d="M20 13.5c0 1.4-.9 2.5-2 2.5s-2-1.1-2-2.5 2-3.5 2-3.5 2 2.1 2 3.5z" />
    </Icon>
);

/** Border colour: a shape's outline, drawn heavy in the selected shape's stroke colour. */
export const BorderIcon = ({ stroke }) => (
    <Icon><rect x="4.5" y="4.5" width="15" height="15" rx="3" strokeWidth="2.8" stroke={stroke || 'currentColor'} /></Icon>
);
